@import "../../globalStyles/commons";

:host {
  display: inline-block;
}

.icon {
  line-height: 0;
  height: 100%;
  width: 100%;
}

:host(:not([size])) svg {
  height: 100%;
  width: 100%;
}

:host(.inherit) .icon {
  color: inherit;
}
